import { Link, createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { getCustomerPortalUrl } from "~/lib/stripe";
import { LoadingSpinner } from "~/routes/__root";

export const Route = createFileRoute("/_authed/dashboard/manage-subscription")({
  component: RouteComponent,
});

function RouteComponent() {
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isCancelled = false;

    void getCustomerPortalUrl({ data: {} })
      .then((url) => {
        if (isCancelled) return;
        window.location.replace(url);
      })
      .catch((cause: unknown) => {
        if (isCancelled) return;
        setError(
          cause instanceof Error
            ? cause.message
            : "Failed to open the Stripe customer dashboard",
        );
      });

    return () => {
      isCancelled = true;
    };
  }, []);

  if (!error) return <LoadingSpinner />;

  return (
    <div className="min-h-screen">
      <div className="relative mx-auto flex min-h-screen max-w-3xl items-center justify-center px-6 py-16 text-center">
        <div>
          <h1 className="text-3xl font-extrabold tracking-tight text-foreground">
            Unable to open billing dashboard
          </h1>
          <p className="mt-3 text-sm text-muted-foreground">{error}</p>
          <Link
            to="/dashboard"
            className="mt-6 inline-flex text-sm font-semibold text-primary"
          >
            Back to dashboard
          </Link>
        </div>
      </div>
    </div>
  );
}
